import { render } from "./ComprobantesAdmin.vue?vue&type=template&id=50548a2c&scoped=true"
import script from "./ComprobantesAdmin.vue?vue&type=script&lang=js"
export * from "./ComprobantesAdmin.vue?vue&type=script&lang=js"

import "./ComprobantesAdmin.vue?vue&type=style&index=0&id=50548a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50548a2c"]])

export default __exports__